import React from 'react';

const units = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
const scales = ["", "Thousand", "Lakh", "Crore"];

function numberToWordsIndian (num)  {
  
  if (num === 0) return "Zero";
  if (num < 0) return "Minus " + numberToWordsIndian(-num);

  let words = "";
  const numStr = num.toString();
  const numLength = numStr.length;

  const getWord = (n) => {
    if (n < 10) return units[n]; // 1-9
    if (n < 20) return teens[n - 10]; // 10-19
    return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + units[n % 10] : ""); // 20+
  };

  let parts = [];
  if (numLength > 7) parts.push(numStr.slice(0, -7)); // Crore part
  if (numLength > 5) parts.push(numStr.slice(-7, -5)); // Lakh part
  if (numLength > 3) parts.push(numStr.slice(-5, -3)); // Thousand part
  parts.push(numStr.slice(-3)); // Last three digits

  let scaleIndex = parts.length - 1;
  parts.forEach((part, i) => {
    let n = parseInt(part, 10);
    if (n !== 0) {
      if (scaleIndex === 0 && n < 100) words += getWord(n) + " ";
      else if (n < 10) words += units[n] + " ";
      else if (n < 100) words += getWord(n) + " ";
      else words += units[Math.floor(n / 100)] + " Hundred " + (n % 100 !== 0 ? getWord(n % 100) + " " : "");

      if (scaleIndex > 0) words += scales[scaleIndex] + " ";
    }
    scaleIndex--;
  });

  return words.trim();
};
export const NumberToWordFormatter = {
  numberToWordsIndian
}
